export class UnverifiedMobileNumberError extends Error {
    public readonly code: number;

    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, UnverifiedMobileNumberError.prototype);
    }
}
